<template>
    <div class="user-pay">
        <!-- 会员价格 -->
        <div class="user-title clearfix">
            <div class="fl">充值会员</div>
        </div>
        <div class="content font-s12">
             <el-row >
                <el-col :span="3" class="c66">订单编号:</el-col>
                <el-col :span="21" class="c99">{{info.order_no}}</el-col>
            </el-row>
            <el-row class="pd-t-20">
                <el-col :span="3" class="c66">订单金额:</el-col>
                <el-col :span="21" class="c99">{{info.price}}元</el-col>
            </el-row>
             <el-row class="pd-t-20">
                <el-col :span="3" class="c66">支付方式:</el-col>
                <el-col :span="21" class="c99">
                    微信支付
                   <div id="qrCode" ref="qrCodeDiv" class="pd-t-20"></div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { Wxpay } from "../../api/api";
import {GetOrderStatus} from "../../api/api";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      //from从哪个页面转入
      item:
        this.$route.query.item == undefined
          ? ""
          : JSON.parse(this.$route.query.item),
      info: ""
    };
  },
  created() {
    this.$axios.post(Wxpay, {}).then(
      res => {
        if (res.data.code == 1) {
          this.info = res.data.data;
          this.$nextTick(function() {
            this.bindQRCode();
          });
           //   获取微信支付后的状态
            this.payStuats();
        } else {
          this.$message.error(res.data.msg);
        }
      },
      err => {
        this.$message.error(err.data.msg);
      }
    );
  },
  mounted: function() {
   
  },
  methods: {
    bindQRCode: function() { //显示二维码
      new QRCode(this.$refs.qrCodeDiv, {
        text: this.info.url,
        width: 200,
        height: 200,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
      });
    },
    payStuats(){
            var db={
                order_no:this.info.order_no
            }
            setInterval(()=>{
                if(this.$route.path=='/userCenter/pay'){
                    this.$axios.post(GetOrderStatus, db).then(
                        res => {
                            if (res.data.code == 1) {
                            if(res.data.data.status=='success'){
                                if(this.item.from!='healthCareDetailResult'){
                                    this.$router.push({name:'userAccountInfo'});  
                                }else{
                                    this.$router.push({name:'healthCareDetailResult',query:{item:JSON.stringify(this.item)}})
                                }
                            }
                            }
                        }
                    );                  
                }
        }, 1000);
    },
  }
};
</script>

<style lang="scss">
.user-pay {
  .content {
    padding: 30px;
  }
}
</style>
